import React from 'react';
import ReactDOM from 'react-dom';
import {
    Col, Row, Table, Modal, Tooltip, OverlayTrigger,
    Form, FormGroup, FormControl, ControlLabel
} from 'react-bootstrap';
import Select from 'react-select';
import decode from 'jwt-decode';
import Button from '../../elements/CustomButton/CustomButton.jsx';
import ModalBlockWrapper from '../Components/ModalBlockWrapper.jsx';

class SolicitudFinanciera extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fecha: !this.props.solicitud ? new Date() : this.props.solicitud.fecha,
      currentUser: decode(localStorage.getItem('id_token')),
      montoAdd: '',
      solicitudAdd: '',
      asistencia: !this.props.solicitud ? '' : {label: this.props.solicitud.asistencia},
      financiamiento: !this.props.solicitud ? '' : {label: this.props.solicitud.financiamiento},
      fechaAdd: '',
      observacionAdd: '',
      solicitudes: !this.props.solicitud ? [] : this.props.solicitud.solicitudes,
      seguimientos: !this.props.solicitud ? [] : this.props.solicitud.seguimientos,
      error: {},
    };
    this.onSave = this.onSave.bind(this);
    this.solicitudesRows = this.solicitudesRows.bind(this);
    this.onClickAdd = this.onClickAdd.bind(this);
    this.checkErrors = this.checkErrors.bind(this);
    this.clearError = this.clearError.bind(this);
  }

  solicitudesRows() {
    const remove = (<Tooltip id="remove_tooltip">Eliminar</Tooltip>);
    const add = (<Tooltip id="add_tooltip">Agregar</Tooltip>);
    const html = [];
    this.state.solicitudes.forEach((item, index) => {
      html.push(
        <tr key={index}>
            <td className="text-center">{item.solicitud}</td>
            <td className="text-center">{item.monto}</td>
            <td>
              <OverlayTrigger placement="top" overlay={remove}>
                <Button bsSize="xs" simple onClick={() => this.removeRow(index)}>
                  <i className="fa fa-times"></i>
                </Button>
              </OverlayTrigger>
            </td>
        </tr>
      )
    });
    html.push(
      <tr key={'userInput'}>
        <td>
          <FormGroup validationState={this.state.error.solicitudes ? 'error': null}>
            <FormControl
              ref="first"
              bsSize="small"
              type="text"
              value={this.state.solicitudAdd}
              onChange={(e) => this.setState({ solicitudAdd: e.target.value })}
            />
          </FormGroup>
        </td>
        <td>
          <FormGroup validationState={this.state.error.solicitudes ? 'error': null}>
            <FormControl
              bsSize="small"
              type="number"
              value={this.state.montoAdd}
              onChange={(e) => this.setState({ montoAdd: e.target.value })}
              onKeyPress={(e) => e.key === 'Enter' && this.onClickAdd(true)}
            />
          </FormGroup>
        </td>
        <td style={{ paddingBottom: 20 }}>
          <OverlayTrigger placement="top" overlay={add}>
            <Button simple onClick={() => this.onClickAdd(false)} disabled={this.state.solicitudAdd === '' || this.state.montoAdd === ''}>
              <i className="fa fa-plus"></i>
            </Button>
          </OverlayTrigger>
        </td>
      </tr>
    );
    return html;
  }

  seguimientoRows() {
    const remove = (<Tooltip id="remove_tooltip">Eliminar</Tooltip>);
    const add = (<Tooltip id="add_tooltip">Agregar</Tooltip>);
    const html = [];
    this.state.seguimientos.forEach((item, index) => {
      html.push(
        <tr key={index}>
            <td className="text-center">{item.fecha}</td>
            <td>{item.observacion}</td>
            <td>
              <OverlayTrigger placement="top" overlay={remove}>
                <Button bsSize="xs" simple onClick={() => this.removeSeguimientoRow(index)}>
                  <i className="fa fa-times"></i>
                </Button>
              </OverlayTrigger>
            </td>
        </tr>
      )
    });
    html.push(
      <tr key={'userInput'}>
          <td>
            <FormGroup>
              <FormControl
                ref="seguimientoFirst"
                bsSize="small"
                type="date"
                value={this.state.fechaAdd}
                onChange={(e) => this.setState({ fechaAdd: e.target.value })}
              />
            </FormGroup>
          </td>
          <td>
            <FormGroup>
              <FormControl
                bsSize="small"
                type="text"
                value={this.state.observacionAdd}
                onChange={(e) => this.setState({ observacionAdd: e.target.value })}
                onKeyPress={(e) => e.key === 'Enter' && this.onClickSeguimientoAdd(true)}
              />
            </FormGroup>
          </td>
          <td style={{ paddingBottom: 20 }}>
            <OverlayTrigger placement="top" overlay={add}>
              <Button simple onClick={() => this.onClickSeguimientoAdd(false)} disabled={this.state.fechaAdd === '' || this.state.observacionAdd === ''}>
                <i className="fa fa-plus"></i>
              </Button>
            </OverlayTrigger>
          </td>
      </tr>
    );
    return html;
  }

  onClickAdd(keyPressed) {
    if (this.state.solicitudAdd === '' || this.state.montoAdd === '') {
      return;
    }
    const auxState = this.state.solicitudes;
    auxState.push({ solicitud: this.state.solicitudAdd, monto: this.state.montoAdd });
    this.setState({
      solicitudes: auxState,
      solicitudAdd: '',
      montoAdd: '',
    });
    if (keyPressed) {
      ReactDOM.findDOMNode(this.refs.first).focus();
    }
    this.clearError('solicitudes');
  }

  onClickSeguimientoAdd(keyPressed) {
    if (this.state.fechaAdd === '' || this.state.observacionAdd === '') {
      return;
    }
    const auxState = this.state.seguimientos;
    auxState.push({ fecha: this.state.fechaAdd, observacion: this.state.observacionAdd });
    this.setState({
      seguimientos: auxState,
      fechaAdd: '',
      observacion: '',
    });
    if (keyPressed) {
      ReactDOM.findDOMNode(this.refs.seguimientoFirst).focus();
    }
  }

  removeRow(index) {
    const auxState = this.state.solicitudes;
    auxState.splice(index, 1);
    this.setState({ solicitudes: auxState });
  }

  removeSeguimientoRow(index) {
    const auxState = this.state.seguimientos;
    auxState.splice(index, 1);
    this.setState({ seguimiento: auxState });
  }

  clearError(key) {
    const auxError = this.state.error;
    auxError[key] = false;
    this.setState({error: auxError});
  }

  checkErrors(solicitud) {
    const fields = ['asistencia', 'financiamiento', 'solicitudes'];
    const auxError = this.state.error;
    let error = false;
    Object.keys(solicitud).forEach((key) => {
      if (fields.includes(key)) {
        if (!solicitud[key] || solicitud[key] === '' || solicitud[key].length === 0) {
          auxError[key] = true;
          error = true;
        }
      }
    });
    this.setState({error: auxError});
    return error;
  }

  onSave() {
    let idEstado;
    switch (this.props.estado) {
      case 'Pre Seleccion':
        idEstado = 3;
        break;
      case 'Pre Incubacion':
        idEstado = 4;
        break;
      case 'Incubacion':
        idEstado = 5;
        break;
      default:
        idEstado = -1;
    }
    let id = null;
    if (this.props.solicitud) {
      id = this.props.solicitud.id;
    }
    const financiamiento = this.state.financiamiento ? this.state.financiamiento.label : '';
    const asistencia = this.state.asistencia ? this.state.asistencia.label : '';
    const solicitud = {
      idproyectoincubacion: this.props.idproyectoincubacion,
      idestado: idEstado,
      iduser: this.state.currentUser.id,
      asistencia,
      financiamiento,
      createdby: this.state.currentUser.username,
      solicitudes: this.state.solicitudes, // array de objetos: { solicitud: text, monto: number }
      seguimientos: this.state.seguimientos, // array de objetos: { fecha: date, observaciones: text }
      idsolicitud: id,
    };

    const error = this.checkErrors(solicitud)

    if (!error) {
      this.props.save(solicitud);
    } else {
      this.props.setError(
        <div>
          Uno o mas campos requeridos no han sido completados!
          <p>
            (Recuerde presionar Enter o clickear el boton {<i className="fa fa-plus"></i>} para agregar efectivamente su solicitud o seguimiento a la lista)
          </p>
        </div>);
    }
  }

  render() {
    const asistencia = [
      { value: 1, label: 'Linea de Crédito' },
      { value: 2, label: 'Concurso' },
      { value: 3, label: 'Inversores' },
      { value: 4, label: 'Otros' },
    ];
    const financiamiento = [
      { value: 1, label: 'ANR' },
      { value: 2, label: 'Préstamo de Honor' },
      { value: 3, label: 'Otro' },
    ];
    const fecha = this.props.solicitud ? this.props.solicitud.fecha : this.state.fecha.toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
    return (
      <Modal show onHide={this.props.cancel} bsSize="large">
        <ModalBlockWrapper
          content={
            <div>
              <Modal.Header closeButton>
                <Modal.Title>Solicitud de Asistencia Financiera</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div>
                  <Form horizontal>
                    <FormGroup>
                      <Col componentClass={ControlLabel} md={3} style={{textAlign:'left', paddingTop: '7px'}}>
                        Etapa:
                      </Col>
                      <Col md={9}>
                        <FormControl
                          type="text" value={this.props.estado}  disabled
                        />
                      </Col>
                    </FormGroup>
                    <FormGroup>
                      <Col componentClass={ControlLabel} md={3} style={{textAlign:'left', paddingTop: '7px'}}>
                        Proyecto:
                      </Col>
                      <Col md={9}>
                        <FormControl
                          type="text" value={this.props.nombreproyecto}  disabled
                        />
                      </Col>
                    </FormGroup>
                    <FormGroup>
                      <Col componentClass={ControlLabel} md={3} style={{textAlign:'left', paddingTop: '7px'}}>
                        Responsable de la Solicitud:
                      </Col>
                      <Col md={9}>
                        <FormControl
                          type="text" value={this.props.solicitud ? this.props.solicitud.responsable : this.state.currentUser.username} disabled
                        />
                      </Col>
                    </FormGroup>
                    <FormGroup>
                      <Col componentClass={ControlLabel} md={3} style={{textAlign:'left', paddingTop: '7px'}}>
                        Fecha de la solicitud:
                      </Col>
                      <Col md={9}>
                        <FormControl
                          type="text" value={fecha.charAt(0).toUpperCase() + fecha.slice(1)} disabled
                        />
                      </Col>
                    </FormGroup>
                  </Form>
                  <Table responsive={true}>
                    <thead>
                      <tr>
                        <th className="text-center">Servicio Solicitado</th>
                        <th className="text-center">Monto Solicitado</th>
                        <th style={{width: 50}}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.solicitudesRows()}
                    </tbody>
                  </Table>
                  <Row>
                    <Col md={6} componentClass={ControlLabel} style={{textAlign:'left', paddingTop: '7px'}}>
                      Tipo de asistencia
                      <Select
                        style={{ borderColor: this.state.error.asistencia ? "#e40040" : "#aaa"}}
                        placeholder="Seleccione uno"
                        closeOnSelect={true}
                        name="assignAssistSelect"
                        value={this.state.asistencia}
                        options={asistencia}
                        onChange={(value) => this.setState({ asistencia: value}, this.clearError('asistencia'))}
                      />
                    </Col>
                    <Col md={6} componentClass={ControlLabel} style={{textAlign:'left', paddingTop: '7px'}}>
                      Financiamiento
                      <Select
                        style={{ borderColor: this.state.error.financiamiento ? "#e40040" : "#aaa"}}
                        placeholder="Seleccione uno"
                        closeOnSelect={true}
                        name="assignFoundingSelect"
                        value={this.state.financiamiento}
                        options={financiamiento}
                        onChange={(value) => this.setState({ financiamiento: value}, this.clearError('financiamiento'))}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12} componentClass={ControlLabel} style={{paddingTop: 20}}>
                      Seguimiento:
                    </Col>
                  </Row>
                  <Table responsive={true}>
                    <thead>
                      <tr>
                        <th style={{width: 100}}>Fecha</th>
                        <th>Observación</th>
                        <th style={{width: 50}}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.seguimientoRows()}
                    </tbody>
                  </Table>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button simple onClick={this.props.cancel}>
                  Cancelar
                </Button>
                <Button
                  bsStyle="success" fill onClick={this.onSave}
                >
                  Guardar
                </Button>
              </Modal.Footer>
            </div>
          }
        />
      </Modal>
    );
  }
}

export default SolicitudFinanciera;



// WEBPACK FOOTER //
// ./src/views/Components/SolicitudFinanciera.jsx